import { Component, OnInit, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RestErrorManager } from '../../angular-common/errors/rest-error-manager';
import { FileSaverService } from 'ngx-filesaver';
import { Observable, Subscription } from 'rxjs';
import { FileTransfer } from '../../angular-common/util';

@Component({
  selector: 'app-file-export-dialog',
  templateUrl: './file-export-dialog.component.html',
  styleUrls: ['./file-export-dialog.component.scss']
})
export class FileExportDialogComponent implements OnInit {

  protected _subscription: Subscription

  download:FileTransfer;
  
  showCancel: boolean;
  title: string;
  message: string;
  countFunction: Function;
  exportFunction: any;
  exportFileName: string;
  rowsNumber: number;

  constructor(
    public dialogRef: MatDialogRef<FileExportDialogComponent>,
    protected _injector: Injector) { }


  async ngOnInit() {

    //count
    try {
      this.rowsNumber = await this.countFunction(false);
    } catch (error) {
      this._injector.get(RestErrorManager).manageError(error);
    }
  }

  public async export() {
    try {

      this._subscription = new Subscription()
            .add(this.exportFunction().subscribe(download=>{
              this.download = download;
              if(this.download && this.download.content)
                this._injector.get(FileSaverService).save(this.download.content as Blob, this.exportFileName)
            }))
    } catch (error) {
      this._injector.get(RestErrorManager).manageError(error);
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this._subscription.unsubscribe();
  }


}
